var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 11.1562C7.30284 11.1562 7.10572 11.0842 6.95542 10.9405L2.22566 6.41457C1.92478 6.12666 1.92478 5.65988 2.22566 5.37209C2.52641 5.0843 3.01413 5.0843 3.31503 5.37209L7.49998 9.37686L11.685 5.37223C11.9858 5.08444 12.4735 5.08444 12.7742 5.37223C13.0753 5.66002 13.0753 6.1268 12.7742 6.41471L8.04455 10.9406C7.89417 11.0844 7.69705 11.1562 7.49998 11.1562Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownBlack);
export default __webpack_public_path__ + "static/media/icon-down.-black.6dfb262adca15d92ecc7bbddd93d7f7d.svg";
export { ForwardRef as ReactComponent };